import React from 'react';
import { Button, Table, Icon, Input } from 'semantic-ui-react';
import 'semantic-ui-css/components/table.min.css';
import { Link, Redirect } from 'react-router-dom';
import MyList, { ADMIN_LIST_FILTER_ROW_CLASS } from './list';

interface CompanyListState {
    filterName: string;
    filterRegister: string;
}

class CompanyList extends MyList {
    entity = "client_company"

    companyState: CompanyListState = {
        filterName: '',
        filterRegister: '',
    };

    setCompanyState(partial: Partial<CompanyListState>) {
        this.companyState = { ...this.companyState, ...partial };
        this.forceUpdate();
    }

    render() {
        if (this.state.redirect) {
            return <Redirect to={this.state.redirect}/>
        }

        const { filterName, filterRegister } = this.companyState;
        const filtered = (this.state?.data || []).filter((row: any) => {
            const nameMatch = !filterName || (row.name || '').toLowerCase().includes(filterName.toLowerCase());
            const regMatch  = !filterRegister || (row.register || '').toLowerCase().includes(filterRegister.toLowerCase());
            return nameMatch && regMatch;
        });

        return (
            <section className="full-width">
                <h2>Худалдан авагч байгууллагын жагсаалт</h2>

                <div className={ADMIN_LIST_FILTER_ROW_CLASS}>
                    <Input
                        icon='search'
                        placeholder='Нэрээр хайх...'
                        value={filterName}
                        onChange={(e) => this.setCompanyState({ filterName: e.target.value })}
                    />
                    <Input
                        icon='search'
                        placeholder='Регистрээр хайх...'
                        value={filterRegister}
                        onChange={(e) => this.setCompanyState({ filterRegister: e.target.value })}
                    />
                </div>

                <Table striped className="admin-list-table" width={16}>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell>№</Table.HeaderCell>
                            <Table.HeaderCell>Нэр</Table.HeaderCell>
                            <Table.HeaderCell>Регистр</Table.HeaderCell>
                            <Table.HeaderCell>Идэвхитэй</Table.HeaderCell>
                            <Table.HeaderCell>Клуб гишүүн</Table.HeaderCell>
                            <Table.HeaderCell>Дараа төлбөрт</Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>

                    <Table.Body>
                        { filtered.map((row: any, index: number) => (
                            <Table.Row key={row.id}>
                                <Table.Cell data-label="№">{ String(index + 1) }</Table.Cell>
                                <Table.Cell data-label="Нэр">
                                    <strong>
                                        <Link className="underline hover-blue" to={"/mongol/company/" + row.id}>{ row.name }</Link>
                                    </strong>
                                </Table.Cell>
                                <Table.Cell data-label="Регистр">{ row.register }</Table.Cell>
                                <Table.Cell data-label="Идэвхитэй">{ row.active ? <Icon name="checkmark"/> : null }</Table.Cell>
                                <Table.Cell data-label="Клуб гишүүн">{ row.clubMember ? <Icon name="checkmark"/> : null }</Table.Cell>
                                <Table.Cell data-label="Paylater">{ row.canPayLater ? <Icon name="checkmark"/> : null }</Table.Cell>
                            </Table.Row>
                        ))}
                    </Table.Body>
                </Table>
            </section>
        );
    }
}

export default CompanyList;
